/**
 * Standardized API error extraction.
 * Replaces the duplicated `ApiError` interfaces and try-catch patterns
 * scattered across components and hooks.
 */

export interface ApiError {
  error?: string;
  message?: string;
  errors?: Array<{ msg?: string; message?: string }>;
}

/**
 * Extracts a human-readable error message from an API error response.
 * @param err - The caught error (unknown type from catch blocks)
 * @param fallback - Default message if no meaningful error is found
 */
export function extractApiError(err: unknown, fallback: string): string {
  if (err && typeof err === 'object') {
    const e = err as ApiError;
    if (e.errors?.length) {
      return e.errors.map((v) => v.msg || v.message).filter(Boolean).join('. ') || fallback;
    }
    return e.error || e.message || fallback;
  }
  if (err instanceof Error) {
    return err.message || fallback;
  }
  return fallback;
}
